/** Enums */
import { BydRunTimeEnum } from '../enums/byd-runtime.enum';
/** Interfaces */
import { BydRuntimeInterface } from '../interfaces/byd-runtime.interface';

/**
 *
 * The BydRuntime environment configuration model.
 *
 * @param bydRuntime the byd runtime configuration
 */
export class BydRuntime<T> {
  /**
   * The environment file url.
   *
   * @default location file '/assets/environments/environment.json'
   * @example '/assets/environments/environment.json'
   */
  url?: string;

  /**
   * The angular buildtime configuration `environment.ts`, will be overridden with the configuration
   * loaded from the environment `JSON` file.
   *
   * This makes the environment configuration accesible from any component & service
   * throuth the `BydRuntimeService`
   *
   * @see https://github.com/sxd-platform/byd-front-libs/blob/master/projects/byd-lib-runtime/README.md
   * @example {
   *            production: true,
   *             settings: {
   *                X_API_URL: 'https://api-x.exmaple.com',
   *                Y_API_URL: 'https://api-y.exmaple.com'
   *              }
   *        }
   */
  environment?: T;

  /**
   * Creates an instance of BydRuntime.
   *
   * @param bydRuntime the byd runtime data.
   */
  constructor(bydRuntime?: BydRuntimeInterface<T>) {
    this.url = bydRuntime && bydRuntime.url ? bydRuntime.url : BydRunTimeEnum.ENVIRONMENT_URL;
    this.environment = bydRuntime && bydRuntime.environment ? bydRuntime.environment : this.environment;
  }
}
